import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import MaintenancePlans from "@/components/MaintenancePlans";
import Stats from "@/components/Stats";
import WhyChooseHHSBuild from "@/components/WhyChooseHHSBuild";
import Portfolio from "@/components/Portfolio";
import BlogSection from "@/components/BlogSection";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <Services />
        <MaintenancePlans />
        <Stats />
        <WhyChooseHHSBuild />
        <Portfolio />
        <BlogSection />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}
